import { SVGProps } from 'react';

const Drumstick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8.29 12.71-2.6 2.6a2.499 2.499 0 0 0-3.369 3.444A2.5 2.5 0 0 0 4.04 19.96 2.5 2.5 0 1 0 8.7 18.3l2.59-2.59m4.11-.08c-1.497.48-2.981.492-4.236.033a4.66 4.66 0 0 1-2.732-2.58c-.52-1.218-.575-2.684-.156-4.183.418-1.5 1.287-2.952 2.48-4.144 1.192-1.193 2.645-2.062 4.144-2.48 1.498-.418 2.965-.364 4.182.156a4.66 4.66 0 0 1 2.581 2.732c.459 1.255.447 2.74-.033 4.236-.695-.396-1.576-.495-2.495-.28-.919.217-1.82.734-2.55 1.465-.732.73-1.249 1.632-1.464 2.55-.216.92-.117 1.8.279 2.495"
    />
  </svg>
);
export default Drumstick;
